import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'
import { config } from '../../../config'
import {
  Grid,
  Paper,
  LinearProgress,
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles'
import { startCase, takeRightWhile } from 'lodash'
import AppTopBar from '../../../components/AppTopBar'
import PlanIntro from './PlanIntro'
import PlanOccasion from './PlanOccasion'
import PlanQuiz from './PlanQuiz'
import PlanAssistance from './PlanAssistance'
import PlanTravel from './PlanTravel'
import PlanCreateAccount from './PlanCreateAccount'
import ReactPixel from 'react-facebook-pixel'
import Cookies from 'universal-cookie'

const cookies = new Cookies();
const API = config.api.TRAVEL_URL


class PlanRequest extends Component {
  constructor(props) {
    super(props)

    this.state = {
      occasion: props.occasion || null,
      assistance: 'ai_planner',
      preferences: null,
      travel: null,
      contact: props.user && props.user.email ? props.user : null,
      isSubmitting: false,

      signinDialogOpened: false,
      signinDialogForce: false,
      signinDialogType: 'signup',
      signinDialogTitle: null,
      signinDialogSubtitle: null,

      error: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
      this.setState({
        contact: this.props.user && this.props.user.email ? this.props.user : null,
      })
    }
  }

  onUpdated = (value) => {
    if (this.props.step === 'occasion' && value.occasion) {
      window.gtag('event', 'request_trip', {step: this.props.step})
      ReactPixel.track('request_trip', {step: this.props.step})

      this.setState(value, this.props.history.push('/request/dates'))

    } else if (this.props.step === 'dates' && value.travel) {
      window.gtag('event', 'request_trip', {step: this.props.step})
      ReactPixel.track('request_trip', {step: this.props.step})

      this.setState(value, this.props.history.push('/request/travel_style'))

    } else if (this.props.step === 'travel_style' && value.preferences) {
      window.gtag('event', 'request_trip', {step: this.props.step})
      ReactPixel.track('request_trip', {step: this.props.step})

      if (this.props.user.is_registered) {
        this.setState(value, this.props.history.push('/request/assistance'))
      } else {
        this.setState(value, this.props.history.push('/request/contact'))
      }

    } else if (this.props.step === 'contact' && value.contact) {
      window.gtag('event', 'request_trip', {step: this.props.step})
      ReactPixel.track('request_trip', {step: this.props.step})

    //   this.setState(value, this.props.history.push('/request/assistance'))

    // } else if (this.props.step === 'assistance' && value.assistance) {
    //   this.setState(value)
    //   window.gtag('event', 'request_trip', {step: this.props.step})
    //   ReactPixel.track('request_trip', {step: this.props.step})

      const user_jwt_token = cookies.get('jwt')

      if (this.props.user.is_registered && user_jwt_token !== undefined) {
        this.setState(value, this.submitRequest)

      } else {
        // sign in or create account before requesting a trip
        this.setState(value, this.openSigninModal)
      }

    } else {

      // if user is signed in skip travel style && signup
      // if (this.props.user && this.props.user.travel_preferences) {
      //   this.setState({occasion: value, preferences: this.props.user.travel_preference, contact: this.props.user}, this.props.history.push('/request/travel_style'))

      // } else {
      //   this.setState({occasion: value}, this.props.history.push('/request/travel_style'))

      // }
    }
  }

  savePreferences = (user, travel_preference) => {
    const user_jwt_token = cookies.get('jwt')

    if (user.is_registered && user_jwt_token !== undefined) {
      // Update user preferences
      fetch(config.api.TRAVEL_URL + '/users/me', {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user_jwt_token}`,
        },
        dataType: 'json',
        // We convert the React state to JSON and send it as the POST body
        body: JSON.stringify({
          travel_preference: travel_preference,
          currency: (cookies.get('curr') ? cookies.get('curr') : 'USD'),
        })
      })
    }
  }

  openSigninModal = () => {
    this.setState({
      signinDialogOpened: true,
      signinDialogForce: true,
      signinDialogTitle: 'Success!',
      signinDialogSubtitle: "Sign in to your account"
    })
  }

  handleSignin = (user) => {
    // save travel preference when user is new
    if (!user.travel_preference && this.state.preferences) {
      this.savePreferences(user, this.state.preferences)
      user.travel_preference = this.state.preferences
    }

    this.props.onSignin(user)
  }

  submitRequest = () => {
    this.setState({isSubmitting: true})
    const user_jwt_token = cookies.get('jwt')

    const travel = this.state.travel || {}
    const dates = travel.dates || {}
    const from = (travel.from != null && travel.from.location) ? travel.from.location : travel.from
    const to = (travel.to != null && travel.to.location) ? travel.to.location : travel.to

    if (user_jwt_token !== undefined) {
      fetch(config.api.TRAVEL_URL + '/travel_plans', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user_jwt_token}`,
        },
        dataType: 'json',
        // We convert the React state to JSON and send it as the POST body
        body: JSON.stringify({
          travel_plan: {
            occasion: this.state.occasion,
            travel_preference_attributes: this.state.preferences,
            search_param_attributes: {
              ...travel.travelers,
              ...{from: from, to: (to || {}), budget: travel.budget, currency: travel.currency},
              ...{
                dates_type: dates.dates_type,
                dates_start: dates.start_date,
                dates_end: dates.end_date,
                dates_nights: dates.nights,
              }
            },
            assistance: this.state.assistance,
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        this.setState({isSubmitting: false})

        if (data.redirect_to) {
          this.setState({error: null})

          window.gtag('event', 'begin_checkout', {value: 4.99, currency: 'USD'})
          ReactPixel.track('InitiateCheckout', {value: 4.99, currency: 'USD'})

          window.location.replace(data.redirect_to);
          return null;
        }

        if (data.errors) {
          this.setState({error: data.errors})
        }
      })

    } else {
      this.openSigninModal()
    }
  }

  progress = () => {
    switch(this.props.step) {
      case 'occasion':
        return 20
      case 'dates':
        return 40
      case 'travel_style':
        return 60
      case 'contact':
        return 80
      case 'assistance':
        return 100
      default:
        return 0
    }
  }

  title = () => {
    switch(this.props.step) {
      case 'occasion':
        return 'Plan a trip: Occasion'
      case 'travel_style':
        return 'Plan a trip: What to do there'
      case 'dates':
        return 'Plan a trip: Where to go'
      case 'assistance':
        return 'Plan a trip: Select a service'
      case 'contact':
        return 'Plan a trip: Contact details'
      default:
        return 'Plan a trip: Introduction'
    }
  }

  subtitle = () => {
    switch(this.props.step) {
      case 'occasion':
        return 'What is an occasion of your trip ?'
      case 'travel_style':
        return 'Describe your trip'
      case 'dates':
        return 'Where would you like to go ?'
      case 'contact':
        return 'What is your contact information ?'
      case 'assistance':
        return 'Plan a trip'
      default:
        return 'Custom trip on demand'
    }
  }

  render() {
    const { classes, user } = this.props

    return (
      <Fragment>
         <Helmet>
          <title>{this.title()}</title>
        </Helmet>
        <AppTopBar
          hideMenu={true}
          hideLogo={false}
          hideCurrency={true}
          hideBottomMenu={true}
          showBackButton={true}
          onLocationChanged={this.props.onLocationChanged}
          onLocationCleared={this.props.onLocationCleared}
          onCurrencyChange={this.handleReloadResults}
          onChange={this.props.onFilterChange}
          onSigninModalChanged={this.handleSigninChange}
          onSignin={this.handleSignin}
          user={this.props.user}
          address={startCase(this.props.address)}
          tabSelected={this.props.tabSelected || 'explore'}
          openedSigninDialog={this.state.signinDialogOpened}
          signinDialogType={this.state.signinDialogType !== null && this.state.signinDialogType}
          signinDialogForce={this.state.signinDialogForce}
          signinDialogTitle={this.state.signinDialogTitle}
          signinDialogSubtitle={this.state.signinDialogSubtitle}
        />

        <div className="destinations explore">
          <div>
            <Paper square className={classes.headlinePaper} style={{marginBottom: 0, paddingBottom: 16, backgroundColor: '#fafafa'}}>
              <h2 className={classes.headline} style={{textAlign: 'center'}}>
                {/* <strong className="main-title" style={{fontWeight: 800}}>
                  Plan a trip
                  <br/>
                </strong> */}
                <small className={classes.subtitle}>
                  {this.subtitle()}
                </small>
              </h2>
            </Paper>
            <LinearProgress variant="determinate" value={this.progress()} />
          </div>

          <Grid container spacing={2} className={classes.gridFilters} justify="center" style={{maxWidth: 800}}>
            {this.state.error && <Grid item xs={12} md={8} className={classes.subtitle}>
                <Alert severity="error" style={{textAlign: 'left', borderRadius: 15, fontWeight: 500}}>
                  <AlertTitle style={{fontWeight: 700, fontSize: 15}}>{(this.state.error && this.state.error.title) || 'Oops. Unable to request a trip'}</AlertTitle>
                  <div>{this.state.error && this.state.error.message}</div>
                  <div>Contact us at <a href="mailto:hi@travelities.com">hi@travelities.com</a></div>
                </Alert>
            </Grid>}

            {(() => {
              switch(this.props.step) {
                case 'travel_style':
                  return <PlanQuiz preferences={this.state.preferences} onUpdated={this.onUpdated} />
                case 'dates':
                  return <PlanTravel user={this.props.user} travel={this.state.travel} onUpdated={this.onUpdated} />
                case 'contact':
                  return <PlanCreateAccount user={this.props.user} contact={this.state.contact} onUpdated={this.onUpdated} onSignin={this.handleSignin}/>
                case 'assistance':
                  return <PlanAssistance assistance={this.state.assistance} onUpdated={this.onUpdated} isSubmitting={this.state.isSubmitting}/>
                case 'occasion':
                  return <PlanOccasion occasion={this.state.occasion} onUpdated={this.onUpdated} />
                default:
                  return <PlanIntro />
              }
            })()}
          </Grid>
        </div>
      </Fragment>
    )
  }
}

const styles = theme => ({
  h3: {
    fontWeight: 700,
    fontSize: 18,
    margin: '0px 5px 15px 5px',
  },
  gridFilters: {
    textAlign: 'left',
    maxWidth: 1142,
    margin: '20px auto 0px auto',
    width: 'calc(100% - 20px)',
    overflow: 'hidden',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: '0px 10px',
    },
  },
  headlinePaper: {
    padding: '0px 0px 40px 0px',
    margin: '-100px auto',
    color: '#333',
    // textAlign: 'left',
    width: '100%',
    position: 'relative',
    boxShadow: 'none',
    height: '100%',
    // minHeight: '60vh',
    paddingBottom: '96px',
    backgroundColor: 'transparent',
    // background: 'linear-gradient(180deg, rgb(26 83 53 / 9%) 0%, rgb(205 214 208 / 77%) 100%)',
  },
  headline: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: '30px',
    padding: '100px 20px 20px 20px',

    [theme.breakpoints.down('xs')]: {
      fontSize: 25,
      padding: '85px 20px 0px 20px',
    },
  },
  subtitle: {
    fontWeight: 700,
    fontSize: '70%',
    color: '#000',
    display: 'block',
    marginBottom: 10,
  },
  listItemIcon: {
    color: '#02c39a',
  },
  listItemText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000',
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextSecondary: {
    fontSize: 14,
    fontWeight: 600,
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextPrice: {
    fontSize: 15,
    fontWeight: 600,
    maxWidth: '70%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'pointer',

    '& .material-icons': {
      color: '#02c39a',
      fontWeight: 300,
      verticalAlign: 'middle',
      margin: '-3px 0px 0px 15px',
    }
  },
  listItemSelected: {
    borderRadius: 15,
    border: '2px solid #02c39a',
  },
  listItem: {
    borderRadius: 15,
    border: '2px solid transparent',

    '&:hover': {
      backgroundColor: '#07c3991a',
    },
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 0px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    padding: 15,
    width: '100%',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
})

export default withRouter(withStyles(styles)(PlanRequest))
